import { c as _c } from "react/compiler-runtime";
import { HOME_PATH, INITIAL_APP_URL } from '@/constants/config';
import { FPageNameEnum } from '@/types/pages';
import { FTunnelPageBookingTypeEnum, FTunnelPageStepEnum } from '@/types/tunnel';
import * as Sentry from '@sentry/react';
import { useEffect, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useInternalFormErrors from './internalHooks/useInternalFormErrors';
import PageContext from './page.context';
const getTunnelStep = (pathname) => {
    const match = pathname.match(/^\/tunnel\/.*\/(.*)\/.*/i);
    return match?.length === 2 &&
        Object.values(FTunnelPageStepEnum).includes(match[1]) ?
        match[1] :
        null;
};
const getExperienceId = (paramsExperienceId) => {
    if (paramsExperienceId) {
        const parsed = parseInt(paramsExperienceId);
        if (!isNaN(parsed)) {
            return parsed;
        }
    }
    return null;
};
const PageProvider = (t0) => {
    const $ = _c(19);
    const { children } = t0;
    const location = useLocation();
    const pageName = location.pathname.startsWith(`/${FPageNameEnum.tunnel}`) ? FPageNameEnum.tunnel :
        location.pathname.startsWith(`/${FPageNameEnum.experience}`) ? FPageNameEnum.experience : FPageNameEnum.home;
    let t1;
    let t2;
    if ($[0] !== location.pathname) {
        t1 = () => {
            Sentry.setTag("react.route", location.pathname);
        };
        t2 = [location.pathname];
        $[0] = location.pathname;
        $[1] = t1;
        $[2] = t2;
    }
    else {
        t1 = $[1];
        t2 = $[2];
    }
    useEffect(t1, t2);
    let t3;
    if ($[3] !== location.pathname) {
        t3 = getTunnelStep(location.pathname);
        $[3] = location.pathname;
        $[4] = t3;
    }
    else {
        t3 = $[4];
    }
    const tunnelStep = t3;
    const bookingType = pageName === FPageNameEnum.tunnel ?
        location.pathname.includes(FTunnelPageBookingTypeEnum.voucher) ? FTunnelPageBookingTypeEnum.voucher : FTunnelPageBookingTypeEnum.standard : null;
    const { experienceId: paramsExperienceId } = useParams();
    let t4;
    if ($[5] !== paramsExperienceId) {
        t4 = getExperienceId(paramsExperienceId);
        $[5] = paramsExperienceId;
        $[6] = t4;
    }
    else {
        t4 = $[6];
    }
    const experienceId = t4;
    const formErrors = useInternalFormErrors();
    const pageChangeEventInitialized = useRef(false);
    let t5;
    let t6;
    if ($[7] !== location.pathname) {
        t5 = () => {
            if (location.pathname !== HOME_PATH || pageChangeEventInitialized.current) {
                pageChangeEventInitialized.current = true;
                const frameId = requestAnimationFrame(_temp);
                return () => {
                    cancelAnimationFrame(frameId);
                };
            }
        };
        t6 = [location.pathname];
        $[7] = location.pathname;
        $[8] = t5;
        $[9] = t6;
    }
    else {
        t5 = $[8];
        t6 = $[9];
    }
    useEffect(t5, t6);
    let t7;
    if ($[10] !== bookingType || $[11] !== experienceId || $[12] !== formErrors || $[13] !== pageName || $[14] !== tunnelStep) {
        t7 = { pageName, tunnelStep, bookingType, experienceId, formErrors };
        $[10] = bookingType;
        $[11] = experienceId;
        $[12] = formErrors;
        $[13] = pageName;
        $[14] = tunnelStep;
        $[15] = t7;
    }
    else {
        t7 = $[15];
    }
    const contextValue = t7;
    let t8;
    if ($[16] !== children || $[17] !== contextValue) {
        t8 = <>
      <PageContext value={contextValue}>{children}</PageContext></>;
        $[16] = children;
        $[17] = contextValue;
        $[18] = t8;
    }
    else {
        t8 = $[18];
    }
    return t8;
};
export default PageProvider;
function _temp() { if (window.top) {
    window.top.postMessage({ wldEventName: "wld-page-change", wldIFrameSrc: INITIAL_APP_URL }, "*");
} }
